import { gql } from 'graphql-request';
import { CREATE_EVENTS, mkEvent } from 'src/services/grapqlQueries/events';
import { useRequestGQLQuery } from 'src/services/grapqlQueries/useGraphQLQuery';



export const GQLCreateEvent = async (data: any) => {
  const event = mkEvent(data)
  const result = await useRequestGQLQuery(gql`${CREATE_EVENTS}`,  { data: [event] });
  return result;
};


  